import localforage from "localforage";

let UserStore = localforage.createInstance({
  driver: localforage.INDEXEDDB, // Force WebSQL; same as using setDriver()
  name: "Teach-r",
  version: 1.0,
  size: 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: "user", // Should be alphanumeric, with underscores.
});
 export default UserStore

 